import { ViewState } from '../../pools/deposit/DepositState'
import { SwapState } from '../SwapState'
import { createTradeTabEvent } from 'user-events-segment'
import { Swap } from '../../../logic/swaps/Swap'
import { fromWei } from '../../../utils/static-web3'
import { oracleApi } from '../../../api/oracle/oracle-client'

const { CONNECT, CHOOSE_TOKEN, CHOOSE_AMOUNT, SWAPPABLE, PREVIEW, SUBMITTING } =
  SwapState

export interface FunnelState {
  state: ViewState
  // state message is typically shown on the Swap button
  stateMessage: string | false
  // will trigger currently a FailPopup
  errorMessage: string | false
}

export interface FunnelAction {
  type:
    | 'connect'
    | 'choose-token'
    | 'choose-amount'
    | 'swappable'
    | 'preview'
    | 'submitting'
    | 'postview'
    | 'show-error'
    | 'clear-error'
  errorMessage?: string
  stateMessage?: string
  swap?: Swap
}

export const FUNNEL_INITIAL_STATE: FunnelState = {
  state: CHOOSE_TOKEN,
  errorMessage: false,
  stateMessage: false,
}

export function funnelReducer(
  funnel: FunnelState,
  action: FunnelAction
): FunnelState {
  switch (action.type) {
    case 'connect':
      return {
        state: CONNECT,
        stateMessage: CONNECT.getMessage(),
        errorMessage: false,
      }
    case 'choose-token':
      return {
        state: CHOOSE_TOKEN,
        stateMessage: CHOOSE_TOKEN.getMessage(),
        errorMessage: false,
      }
    case 'choose-amount':
      return {
        state: CHOOSE_AMOUNT,
        stateMessage: action.stateMessage || CHOOSE_AMOUNT.getMessage(),
        errorMessage: action.errorMessage || false,
      }
    case 'swappable':
      return {
        state: SWAPPABLE,
        stateMessage: SWAPPABLE.getMessage(),
        errorMessage: false,
      }
    case 'preview':
      const previewSwap = action.swap!
      clicked_preview_trade(previewSwap)
      return {
        state: PREVIEW,
        stateMessage: PREVIEW.getMessage(),
        errorMessage: false,
      }
    case 'submitting':
      const submittedSwap = action.swap!
      clicked_confirm_trade(submittedSwap)
      return {
        state: SUBMITTING,
        stateMessage: SUBMITTING.getMessage(),
        errorMessage: false,
      }
    case 'show-error':
      if (!action.errorMessage) {
        console.warn('No error message sent')
        action.errorMessage = 'Transaction cancelled'
      }
      return {
        ...funnel,
        errorMessage: action.errorMessage,
      }
    case 'clear-error':
      return {
        ...funnel,
        errorMessage: false,
      }
  }

  return funnel
}

function clicked_preview_trade(swap: Swap) {
  const tokenIn = swap.tokenIn
  const tokenOut = swap.tokenOut
  const amountIn = fromWei(swap.inAmountWei!, tokenIn.decimals)
  createTradeTabEvent().clicked_preview_trade(
    tokenIn.symbol,
    tokenOut.symbol,
    fromWei(swap.inAmountWei || '0', tokenIn.decimals),
    oracleApi.getPrice(tokenIn.symbol) * amountIn,
    swap.slippage
  )
}

function clicked_confirm_trade(swap: Swap) {
  const tokenIn = swap.tokenIn
  const tokenOut = swap.tokenOut
  const amountIn = fromWei(swap.inAmountWei!, tokenIn.decimals)
  createTradeTabEvent().clicked_confirm_trade(
    tokenIn.symbol,
    tokenOut.symbol,
    fromWei(swap.inAmountWei || '0', tokenIn.decimals),
    fromWei(swap.expectedOutAmountWei || '0', tokenOut.decimals),
    fromWei(swap.calculateMinAmountWei() || '0', tokenOut.decimals),
    oracleApi.getPrice(tokenIn.symbol) * amountIn,
    swap.slippage
  )
}
